import { render, staticRenderFns } from "./ColumnWithHelp.vue?vue&type=template&id=c67f4924"
import script from "./ColumnWithHelp.vue?vue&type=script&lang=js"
export * from "./ColumnWithHelp.vue?vue&type=script&lang=js"
import style0 from "./ColumnWithHelp.vue?vue&type=style&index=0&id=c67f4924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports